export default __webpack_public_path__ + "static/media/quest.98eef9c1.svg";